<template>
  <div class="basket-box-modal-description">
    <p class="basket-box-modal-description__type">
      {{ result?.type }}
    </p>
    <p class="basket-box-modal-description__name">
      {{ result?.name }}
    </p>
    <DefPrice v-if="result?.price?.printPrice">
      {{ result?.price?.printPrice }}
    </DefPrice>
    <DefBuy :result="result" @click="handlerBuy">
      <template #inBasket>
        {{ messages.inBasket }}
      </template>
      {{ messages.buy }}
    </DefBuy>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefBuy from '@components/Def/DefBuy/DefBuy.vue';
import useModalAside from '@use/useModalAside/useModalAside';
import useBasketState from '@use/useBasketState';

export default {
  name: 'BasketBoxModalDescription',
  components: {
    DefPrice,
  },
  props: ['result', 'product'],
  data() {
    return {
      modalAside: useModalAside(),
      basketState: useBasketState(),
    };
  },
  computed: {
    ...mapState({
      messages: ({ basket }) => basket.data.messages,
    }),
    productId() {
      return this.product?.offer?.id || this.product?.id;
    },
    id() {
      return this.result?.offer?.id || this.result?.id;
    },
  },
  beforeCreate: function () {
    this.$options.components.DefBuy = DefBuy;
  },
  methods: {
    async handlerBuy() {
      await this.modalAside.hide();
      // this.basketState.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.basket-box-modal-description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  &__type {
    font-size: 16px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 8px;
    @include point-md {
      font-size: 18px;
    }
  }
  &__name {
    font-size: 12px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 16px;
    color: var(--color-dark-grey);
    @include point-md {
      margin-bottom: 24px;
    }
  }
  &__icon {
    display: block;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    fill: #fff;
  }
  :deep(.def-price) {
    display: block;
    font-size: 16px;
    margin-bottom: 16px;
    @include point-md {
      font-size: 20px;
    }
  }
  :deep(.def-buy) {
    width: 100%;
  }
}
</style>
